<template>
    <b-modal id="AdvertiseModal" hide-footer hide-header ref="advertiseModal">
        <div id="form-loader" ref="loader" class="form-loader-overlay">
            <span class="spinner"></span>
            <div class="sucess-icon-container success-icon">
                <svg class="ft-green-tick" xmlns="http://www.w3.org/2000/svg" height="100" width="100"
                    viewBox="0 0 48 48" aria-hidden="true">
                    <circle class="circle" fill="#5bb543" cx="24" cy="24" r="22" />
                    <path class="tick" fill="none" stroke="#FFF" stroke-width="6" stroke-linecap="round"
                        stroke-linejoin="round" stroke-miterlimit="10" d="M14 27l5.917 4.917L34 17" />
                </svg>
            </div>
        </div>
        <div class="advertise-modal-wrapper">
            <div class="advertise-modal-image-bloc">
                <img src="@/assets/img/triplea/home/advertise-modal-image.png" />
            </div>
            <div class="advertise-modal-content-bloc">
                <div class="advertise-modal-content-title-row">
                    <h3>Anuncie seu imóvel</h3>
                    <button class="modal-close-button" @click="closeModal">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M4.22259 4.22208C4.65216 3.79251 5.34865 3.79251 5.77822 4.22208L12.0004 10.4443L18.2226 4.22208C18.6522 3.79251 19.3486 3.79251 19.7782 4.22208C20.2078 4.65166 20.2078 5.34814 19.7782 5.77772L13.556 11.9999L19.7782 18.2221C20.2078 18.6517 20.2078 19.3482 19.7782 19.7777C19.3487 20.2073 18.6522 20.2073 18.2226 19.7777L12.0004 13.5555L5.77821 19.7777C5.34863 20.2073 4.65215 20.2073 4.22257 19.7777C3.793 19.3482 3.793 18.6517 4.22257 18.2221L10.4448 11.9999L4.22259 5.77772C3.79301 5.34814 3.79301 4.65166 4.22259 4.22208Z"
                                fill="#333333" />
                        </svg>
                    </button>
                </div>
                <div class="advertise-modal-content-resume-row">
                    <p>
                        Simples e prático, após preencher os seus dados abaixo uma equipe especializada entrará em
                        contato.
                    </p>
                </div>
                <div class="advertise-modal-content-form-row">
                    <form class="main-modal-form" @submit.prevent="submitProposal">
                        <div class="advertise-modal-line">
                            <label class="advertise-modal-line-label">Esse imóvel está para:</label>
                            <div class="advertise-modal-button-wrapper" data-toggle="buttons">
                                <label :class="{ active: selectedValue === 'vender' }"
                                    @click="selectValue('vender')">Vender</label>
                                <label :class="{ active: selectedValue === 'alugar' }"
                                    @click="selectValue('alugar')">Alugar</label>
                            </div>
                        </div>

                        <div class="advertise-modal-form-line-properties-type">
                            <label>Qual o tipo desse imóvel?</label>
                            <div class="advertise-modal-form-properties-type-box">
                                <div v-for="type in propertyTypes" :key="type.value"
                                    class="advertise-modal-form-properties-type-item"
                                    :class="{ active: selectedPropertyTypes.includes(type.value) }"
                                    @click="togglePropertyType(type.value)">
                                    <img :src="type.icon" :alt="type.label" />
                                    <p>{{ type.label }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="advertise-modal-form-line">
                            <label class="advertise-modal-form-label">
                                <span>Qual a localização?</span>
                                <input v-model="formData.address" class="advertise-modal-form-input" type="text"
                                    placeholder="Endereço completo" required />
                            </label>
                        </div>

                        <div class="advertise-modal-form-line">
                            <label class="advertise-modal-form-label">
                                <span>Seu nome</span>
                                <input v-model="formData.name" class="advertise-modal-form-input" type="text"
                                    placeholder="Nome completo" required />
                            </label>
                        </div>
                        <div class="advertise-modal-form-line">
                            <label class="advertise-modal-form-label">
                                <span>Seu e-mail</span>
                                <input v-model="formData.email" class="advertise-modal-form-input" type="email"
                                    placeholder="Apolino@apolar.com.br" required />
                            </label>
                        </div>
                        <div class="advertise-modal-form-line">
                            <label class="advertise-modal-form-label">
                                <span>Telefone</span>
                                <input v-model="formData.phone" class="advertise-modal-form-input" type="phone"
                                    v-mask="phone_mask" placeholder="(00) 00000-0000" required />
                            </label>
                        </div>
                        <div class="advertise-modal-form-button-line">
                            <button id="proposalSubmitButton" class="advertise-modal-form-button" :disabled="isLoading"
                                type="submit">
                                Quero uma proposta
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
import "@/assets/scss/custom/triplea/components/_home_advertise_modal.scss"
import { mask } from 'vue-the-mask'
export default {
    data() {
        return {
            selectedValue: 'vender',
            propertyTypes: [
                { value: '000001', label: 'Apartamento', icon: require('@/assets/img/triplea/home/filter-icons/modal/apartamento.svg') },
                { value: '000002', label: 'Casa e sobrado', icon: require('@/assets/img/triplea/home/filter-icons/modal/casa-e-sobrado.svg') },
                { value: '000009', label: 'Comercial', icon: require('@/assets/img/triplea/home/filter-icons/modal/comercial.svg') },
                { value: '000013', label: 'Terreno', icon: require('@/assets/img/triplea/home/filter-icons/modal/terreno.svg') }
            ],
            selectedPropertyTypes: ['000001'],
            formData: {
                name: '',
                email: '',
                phone: '',
                address: ''
            },
            isLoading: false,
            isSuccess: false
        };
    },
    directives: { mask },
    computed: {
        phone_mask() {
            let mask = ['(##) #####-####']

            return mask
        }
    },
    methods: {
        showLoading() {
            const loader = this.$refs.loader
            loader.style.display = 'flex'
            loader.style.opacity = 0
            let op = 0
            const fadeIn = setInterval(() => {
                op += 0.1
                loader.style.opacity = op
                if (op >= 1) clearInterval(fadeIn)
            }, 50)
        },
        showSuccess() {
            const loader = this.$refs.loader
            loader.classList.add('success-icon')
            const spinner = loader.querySelector('.spinner')
            const icon = loader.querySelector('.success-icon')
            spinner.style.display = 'none'
            icon.style.display = 'flex'
            setTimeout(() => this.hideLoading(), 1800)
        },
        hideLoading() {
            const loader = this.$refs.loader
            loader.classList.remove('success-icon')
            const spinner = loader.querySelector('.spinner')
            const icon = loader.querySelector('.success-icon')
            let op = 1
            const fadeOut = setInterval(() => {
                op -= 0.1
                loader.style.opacity = op
                if (op <= 0) {
                    clearInterval(fadeOut)
                    loader.style.display = 'none'
                    spinner.style.display = 'flex'
                    icon.style.display = 'none'
                }
            }, 50)
        },
        selectValue(value) {
            this.selectedValue = value;
        },
        togglePropertyType(type) {
            const idx = this.selectedPropertyTypes.indexOf(type);
            if (idx === -1) this.selectedPropertyTypes.push(type);
            else this.selectedPropertyTypes.splice(idx, 1);
        },
        closeModal() {
            this.$refs.advertiseModal.hide();
        },
        async submitProposal() {
            this.showLoading()

            await new Promise(r => setTimeout(r, 500));

            let negocio = this.selectedValue === 'vender' ? '3' : '1';
            let endpoint = this.selectedValue === 'vender'
                ? 'https://sales2.ops.digital/api/1.1/wf/landing_pages'
                : 'https://crm.ops.digital/api/1.1/wf/lp_anuncie';
            let token = this.selectedValue === 'vender'
                ? 'Bearer 5e63acdfad16f8aeb8a1e9223e2b301c'
                : 'Bearer 71f2608e24fb00bead6c3e8385194a48';

            const payload = {
                origem: '30',
                negocio,
                finalidade: 'Residencial',
                tipo_imovel: [...new Set(this.selectedPropertyTypes)].join(', '),
                nome: this.formData.name,
                email: this.formData.email,
                telefone: this.formData.phone,
                endereco: this.formData.address
            };

            try {
                const res = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token
                    },
                    body: JSON.stringify(payload)
                });
                const data = await res.json();

                await new Promise(r => setTimeout(r, 500));

                if (data.status === 'success') {
                    this.showSuccess()
                    setTimeout(() => {
                        this.hideLoading()
                        this.isSuccess = false;
                        this.resetForm();
                        this.closeModal();
                    }, 1500);
                } else {
                    this.hideLoading()
                    alert('Erro ao enviar a proposta, tente novamente mais tarde.');
                }
            } catch (err) {
                this.hideLoading()
                alert('Erro ao enviar a proposta, tente novamente mais tarde.');
            }
        },
        resetForm() {
            this.selectedValue = 'vender';
            this.selectedPropertyTypes = ['000001'];
            this.formData = { name: '', email: '', phone: '', address: '' };
        }
    }
};
</script>
<style scoped>
.form-loader-overlay {
    display: none;
    opacity: 0;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    transition: opacity 0.5s ease;
    cursor: not-allowed;
}

.form-loader-overlay .spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #fff;
    border-top: 5px solid var(--supernova);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.sucess-icon-container {
    display: none;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

@supports (animation: grow .5s cubic-bezier(.25, .25, .25, 1) forwards) {
    .sucess-icon-container .tick {
        stroke-opacity: 0;
        stroke-dasharray: 29px;
        stroke-dashoffset: 29px;
        animation: draw .5s cubic-bezier(.25, .25, .25, 1) forwards;
        animation-delay: .6s
    }

    .sucess-icon-container .circle {
        fill-opacity: 0;
        stroke: #219a00;
        stroke-width: 16px;
        transform-origin: center;
        transform: scale(0);
        animation: grow 1s cubic-bezier(.25, .25, .25, 1.25) forwards;
    }
}

@keyframes grow {
    60% {
        transform: scale(.8);
        stroke-width: 4px;
        fill-opacity: 0;
    }

    100% {
        transform: scale(.9);
        stroke-width: 8px;
        fill-opacity: 1;
        fill: #219a00;
    }
}

@keyframes draw {

    0%,
    100% {
        stroke-opacity: 1;
    }

    100% {
        stroke-dashoffset: 0;
    }
}

.form-loader-overlay.success-icon .spinner {
    display: block;
}

.form-loader-overlay.success-icon .sucess-icon-container {
    display: block;
}

.advertise-modal-form-properties-type-item.active {
    border: 2px solid var(--supernova);
    background-color: rgba(255, 234, 0, 0.15);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    transition: all 0.2s ease;
}
</style>
